import asyncComponent from '../../utils/AsyncFunc';

const routes = [
  {
    path: '/reports/',
    component: asyncComponent(() => import('./'))
  }
];

export default routes;
